/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Long_Quick_Martin_BuzzInputs */

const fr_long_quick_martin_buzz = /** @type {(inputs: Long_Quick_Martin_BuzzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d'utilisateur`)
};

/**

* @param {Long_Quick_Martin_BuzzInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const long_quick_martin_buzz = /** @type {((inputs?: Long_Quick_Martin_BuzzInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Long_Quick_Martin_BuzzInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_long_quick_martin_buzz(inputs)
});